export default __webpack_public_path__ + "static/media/119t.1105d237.jpg";